import { apiRequest } from '../../../shared/services/apiClient';
import type { AiTokenBudget, UpdateAiTokenBudgetRequest } from '../types/tokenBudget';

const pickSingle = (payload: any): any => {
  if (!payload || typeof payload !== 'object') return null;
  if (payload.data && typeof payload.data === 'object') return payload.data;
  return payload;
};

const numberOr = (value: unknown, fallback: number): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const normalizeAiTokenBudget = (value: any): AiTokenBudget => ({
  maxTokens: Math.max(0, Math.floor(numberOr(value?.maxTokens, 0))),
  tokensUsed: Math.max(0, Math.floor(numberOr(value?.tokensUsed, 0))),
  tokensRemaining: value?.tokensRemaining == null ? null : Math.max(0, Math.floor(numberOr(value.tokensRemaining, 0))),
  isExceeded: Boolean(value?.isExceeded),
});

export const getAiTokenBudget = async (): Promise<AiTokenBudget> => {
  const payload = await apiRequest<any>('/api/v1/ai/token-budget');
  return normalizeAiTokenBudget(pickSingle(payload));
};

export const updateAiTokenBudget = async (
  request: UpdateAiTokenBudgetRequest,
): Promise<AiTokenBudget> => {
  const payload = await apiRequest<any>('/api/v1/ai/token-budget', {
    method: 'PUT',
    body: JSON.stringify(request),
  });
  return normalizeAiTokenBudget(pickSingle(payload));
};

export const resetAiTokenBudget = async (): Promise<AiTokenBudget> => {
  const payload = await apiRequest<any>('/api/v1/ai/token-budget', {
    method: 'DELETE',
  });
  return normalizeAiTokenBudget(pickSingle(payload));
};
